var React = require('react');

function WorkLifeBalance (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M51.2 8H8.4c-.6 0-1-.4-1-1s.4-1 1-1h42.9c.6 0 1 .4 1 1s-.5 1-1.1 1z","key":0}),React.createElement("path",{"d":"M8.4 8C4.3 8 .8 5.1 0 1.2 0 .9 0 .6.2.4S.7 0 1 0h14.7c.3 0 .6.1.8.4s.3.5.2.8C15.9 5.1 12.4 8 8.4 8zm0-2c2.7 0 5-1.6 6-4h-12c.9 2.4 3.3 4 6 4zm42.8 2c-4 0-7.5-2.9-8.3-6.8-.1-.3 0-.6.2-.8.2-.3.5-.4.8-.4h14.7c.3 0 .6.1.8.4.2.2.3.5.2.8-.8 3.9-4.4 6.8-8.4 6.8zm0-2c2.7 0 5-1.6 6-4h-12c1 2.4 3.4 4 6 4zM35.7 32H23.9c-.3 0-.6-.1-.8-.4s-.3-.6-.2-.9l5.9-24c.1-.4.5-.8 1-.8s.9.3 1 .8l5.9 24c.1.3 0 .6-.2.9-.2.2-.5.4-.8.4zm-10.6-2h9.3l-4.7-18.8L25.1 30z","key":1}),React.createElement("path",{"d":"M38.9 36.8h-19c-.6 0-1-.4-1-1V31c0-.6.4-1 1-1h19c.6 0 1 .4 1 1v4.8c0 .5-.4 1-1 1zm-18-2h17V32h-17v2.8z","key":2})]);
}

WorkLifeBalance.defaultProps = {"fill":"currentColor","viewBox":"0 0 59.6 36.8"};

module.exports = WorkLifeBalance;

WorkLifeBalance.default = WorkLifeBalance;
